import React from "react";

const AlertContext = React.createContext(null);

export default AlertContext;
